import * as React from "react";
import { Icon, Popup } from "semantic-ui-react";
import { FieldPath, useFormContext, useWatch } from "react-hook-form";
import { PlayerCardWidgetOwner, PolymorphicPlayerCard } from "../../../../../../services/bedrock";

interface DisplayFieldLabelProps {
  index: number;
  label: string;
  fieldName: FieldPath<PlayerCardWidgetOwner>;
}

const DisplayFieldLabel: React.FC<DisplayFieldLabelProps> = ({ index, label, fieldName }) => {
  const { control, setValue } = useFormContext<PolymorphicPlayerCard>();
  const displayField = useWatch({ control, name: `widgets.${index}.owner.${fieldName}` });

  return (
    <div className="displayFieldLabel">
      <span>{label}</span>
      <Popup
        content={`Toggle to ${displayField ? "hide" : "show"} this field.`}
        on="hover"
        trigger={
          <Icon
            name={displayField ? "eye" : "eye slash"}
            onClick={() => {
              setValue(`widgets.${index}.owner.${fieldName}`, !displayField, { shouldDirty: true });
            }}
          />
        }
      />
    </div>
  );
};
export default DisplayFieldLabel;
